export const validCivilStatuses = [
  'married',
  'alleenstaand',
  'gehuwd',
  'living-together',
  'samenwonend',
  'registered-partnership',
  'registered_partners',
  'geregistreerd partnerschap',
  'divorced',
  'gescheiden',
  'single',
  'ongehuwd',
  'widower',
  'weduwe/weduwnaar',
  'unknown',
  'overig',
  'living-together-with-agreement',
  'living-together-without-agreement',
];

export const employeesTemplateHeaders = [
  'personnelNumber',
  'socialSecurityNumber',
  'personName.initials',
  'personName.firstName',
  'personName.lastNamePrefix',
  'personName.lastName',
  'civilStatus',
  'gender',
  'dateOfBirth',
  'dateOfDeath',
  'emailAddress',
  'costCenter',
  'profession',
  'address.street',
  'address.houseNumber',
  'address.houseNumberSuffix',
  'address.zipCode',
  'address.city',
  'address.country',
  'employment.partTimePercentage',
  'employment.wage.grossWage',
  'employment.startDate',
  'employment.yearsFrom',
  'employment.endDate',
  'employment.emoluments',
  'partner.socialSecurityNumber',
  'partner.personName.initials',
  'partner.personName.firstName',
  'partner.personName.lastNamePrefix',
  'partner.personName.lastName',
  'partner.gender',
  'partner.dateOfBirth',
  'partner.dateOfDeath',
  'partner.startOfRelationship',
  'partner.endOfRelationship',
  'children[0].socialSecurityNumber',
  'children[0].personName.initials',
  'children[0].personName.firstName',
  'children[0].personName.lastNamePrefix',
  'children[0].personName.lastName',
  'children[0].gender',
  'children[0].dateOfBirth',
  'children[1].socialSecurityNumber',
  'children[1].personName.initials',
  'children[1].personName.firstName',
  'children[1].personName.lastNamePrefix',
  'children[1].personName.lastName',
  'children[1].gender',
  'children[1].dateOfBirth',
  'children[2].socialSecurityNumber',
  'children[2].personName.initials',
  'children[2].personName.firstName',
  'children[2].personName.lastNamePrefix',
  'children[2].personName.lastName',
  'children[2].gender',
  'children[2].dateOfBirth',
];
